import React from "react";
import BannerBg from "../assets/img/banner.png";

const Banner = () => {
  return (
    // <div className="bg-banner container mx-auto py-16 px-8 rounded-2xl mt-24  bg-no-repeat bg-cover">
    //   <div className="flex flex-wrap items-center justify-between">
    //     <div className="text-white md:w-1/2">
    //       <h3 className="text-4xl font-bold ">
    //         Choose from over 500+ Schools to study abroad
    //       </h3>
    //       <p className="opacity-80 mt-4">
    //         Let’s guide you through every step of the application process to any
    //         university of your choice
    //       </p>
    //     </div>
    //     <div className="mt-5 md:mt-0">
    //       <a
    //         href="/application"
    //         className="uppercase text-white bg-primary  py-3 px-8 rounded-full hover:bg-gray-cool duration-500"
    //       >
    //         start application
    //       </a>
    //     </div>
    //   </div>

    // </div>

    <div className="relative container mx-auto w-full h-[300px] md:h-[300px] mt-24 overflow-hidden group sm:rounded-3xl">
      <img
        src={BannerBg}
        alt="Background"
        className="w-full h-full object-cover sm:rounded-3xl transition-transform duration-500 group-hover:scale-110"
      />

      <div className="absolute inset-0 px-4 md:px-0 flex items-center justify-center">
        <div className="flex flex-wrap items-center justify-between">
          <div className="text-white md:w-1/2">
            <h3 className="text-3xl md:text-4xl font-bold ">
              Choose from over 500+ Schools to study abroad
            </h3>
            <p className="opacity-80 mt-4 text-base">
              Let’s guide you through every step of the application process to
              any university of your choice
            </p>
          </div>
          <div className="mt-5 md:mt-0">
            <a
              href="/application"
              className="uppercase text-white bg-secondary  py-3 px-8 rounded-full hover:bg-gray-cool duration-500"
            >
              start application
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
